import { computed, unref } from 'vue';

function listaValores(valores) {
  const lista = unref(valores);
  return Array.isArray(lista) ? lista : [];
}

export function estanTodosSeleccionados(seleccionados, valores) {
  const vals = listaValores(valores);
  const sel = unref(seleccionados) ?? [];
  return vals.length > 0 && vals.every((valor) => sel.includes(valor));
}

export function seleccionarTodosEnRef(seleccionadosRef, valores) {
  seleccionadosRef.value = [...listaValores(valores)];
}

export function deseleccionarTodosEnRef(seleccionadosRef) {
  seleccionadosRef.value = [];
}

/**
 * Gestiona selección múltiple sobre un array de ids/valores.
 *
 * @param seleccionadosRef - Array reactivo con la selección actual
 * @param valores - Universo seleccionable
 */
export function useSeleccionMultiple(seleccionadosRef, valores) {
  const todosSeleccionados = computed(
    () => estanTodosSeleccionados(seleccionadosRef, valores),
  );

  function toggleTodos() {
    if (todosSeleccionados.value) {
      deseleccionarTodosEnRef(seleccionadosRef);
    } else {
      seleccionarTodosEnRef(seleccionadosRef, valores);
    }
  }

  function seleccionarTodos() {
    seleccionarTodosEnRef(seleccionadosRef, valores);
  }

  function deseleccionarTodos() {
    deseleccionarTodosEnRef(seleccionadosRef);
  }

  function toggleValor(valor) {
    const idx = seleccionadosRef.value.indexOf(valor);
    if (idx >= 0) {
      seleccionadosRef.value.splice(idx, 1);
    } else {
      seleccionadosRef.value.push(valor);
    }
  }

  function establecerValor(valor, seleccionado) {
    const idx = seleccionadosRef.value.indexOf(valor);
    if (seleccionado && idx < 0) {
      seleccionadosRef.value.push(valor);
    } else if (!seleccionado && idx >= 0) {
      seleccionadosRef.value.splice(idx, 1);
    }
  }

  return {
    todosSeleccionados,
    toggleTodos,
    seleccionarTodos,
    deseleccionarTodos,
    toggleValor,
    establecerValor,
  };
}
